<template>
  <div>
    <table class="table">
      <tr>
        <td style="text-align:left">
          <button
            type="button"
            class="btn btn-outline btn-outline-dark btn-active-light-dark"
            v-on:click="goToBack()"
          >
            <img src="../assets/left.png" />
            Volver
          </button>
        </td>
        <td style="text-align:right">
          <!--
          <button
            type="button"
            style="background-color: #2aa352"
            class="btn btn-primary btn-circle btn-sm"
            v-on:click="shareOnWhatsapp()"
          >
            <img src="../assets/whatsapp.png" />
          </button>


          &nbsp; -->
          <button
            type="button"
            style="background-color: #1855e2"
            class="btn btn-primary btn-circle btn-sm"
            v-on:click="share()"
          >
            <img src="../assets/share.png" />
          </button>
        </td>
      </tr>
    </table>

    <div class="card shadow-sm">
      <div class="card-body">
        <div v-if="images.length == 1">
          <div class="text-center">
            <img :src="images[0]" class="rounded img-size" />
          </div>
        </div>
        <div v-else>
          <div style="width:100%;height:300px">
            <slider ref="slider">
              <slideritem v-for="(item, index) in images" :key="index">
                <img
                  :src="images[index]"
                  class="img-responsive"
                  style="width: 300px"
                />
              </slideritem>

              <div slot="loading">Cargando imágenes...</div>
            </slider>
          </div>
        </div>
        <br />
        <h2>{{ currentProduct.name }}</h2>
        <h6 style="color: #28a351">
          <img src="../assets/thumb-up.png" style="max-height: 15px;" /> Pago
          en efectivo contra entrega
        </h6>
        <div class="d-flex flex-row bd-highlight ">
          <div class="bd-highlight align-self-center">
            <money-format
              :value="currentProduct.group_price"
              :locale="locale"
              :currency-code="currencyCode"
              :subunits-value="false"
              :hide-subunits="true"
              style="font-size: 1.5em"
            >
            </money-format>
          </div>
          <div class="p-2 bd-highlight">Precio Grupal</div>
        </div>
        <div class="d-flex flex-row bd-highlight ">
          <div class="bd-highlight align-self-center">
            <money-format
              :value="currentProduct.price"
              :locale="locale"
              :currency-code="currencyCode"
              :subunits-value="false"
              :hide-subunits="true"
              style="font-size: 1.2em"
            >
            </money-format>
          </div>
          <div class="p-2 bd-highlight">Precio Normal</div>
        </div>

        <div class="row">
          <div class="col-12">
            <button
              type="button"
              class="btn btn-outline btn-outline btn-outline-primary btn-active-light-primary"
              style="width: 100%; font-weight: bold"
              v-on:click="buySingle()"
            >
              <img src="../assets/cart.png" /> Comprar ahora
            </button>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12">
            <button
              type="button"
              class="btn btn-primary input-block-level"
              style="width: 100%; display: inline; font-weight: bold"
              v-on:click="buyGroup()"
            >
              <div class="row-div">
                <div><img src="../assets/group.png" /></div>
                <div style="padding: 3px 0px; margin-right: 2px;">
                  Comprar en grupo por
                </div>
                <div style="padding: 3px">
                  <money-format
                    :value="currentProduct.group_price"
                    :locale="locale"
                    :currency-code="currencyCode"
                    :subunits-value="false"
                    :hide-subunits="true"
                  >
                  </money-format>
                </div>
              </div>
            </button>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12 link">
            <router-link :to="{ name: 'HowGroupBuyingWorks' }"
              >¿Cómo funcionan las compras en grupo?</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="card shadow-sm">
      <div class="card-body">
        <ul
          class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6"
          id="myTab"
          role="tablist"
        >
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home"
              type="button"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >
              Descripción
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
            >
              Ficha técnica
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            {{ currentProduct.description }}
          </div>
          <div
            class="tab-pane fade"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            {{ currentProduct.tech_report }}
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="card shadow-sm">
      <div class="card-body">
        <div class="row">
          <div class="col-md-1">
            <img
              style="max-width: 50px !important; text-align: 'center'"
              :src="currentProduct.cover"
              class="img img-responsive"
            />
          </div>
          <div class="col-md-11">
            <b>{{ currentProduct.name }}</b>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12">
            <button
              type="button"
              class="btn btn-outline btn-outline btn-outline-primary btn-active-light-primary"
              style="width: 100%; font-weight: bold"
              v-on:click="buySingle()"
            >
              Comprar ahora
            </button>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12">
            <button
              type="button"
              class="btn btn-primary input-block-level"
              style="width: 100%; display: inline; font-weight: bold"
              v-on:click="buyGroup()"
            >
              <div class="row-div">
                <div><img src="../assets/group.png" /></div>
                <div style="    padding: 3px 0px; margin-right: 2px;">
                  Comprar en grupo por
                </div>
                <div style="padding: 3px">
                  <money-format
                    :value="currentProduct.group_price"
                    :locale="locale"
                    :currency-code="currencyCode"
                    :subunits-value="false"
                    :hide-subunits="true"
                  >
                  </money-format>
                </div>
              </div>
            </button>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-12 link">
            <router-link :to="{ name: 'HowGroupBuyingWorks' }"
              >¿Cómo funcionan las compras en grupo?</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { slider, slideritem } from "vue-concise-slider"; // import slider components
import MoneyFormat from "vue-money-format";
import { uuid } from "vue-uuid";

export default {
  name: "product-detail",
  components: {
    slider: slider,
    slideritem: slideritem,
    "money-format": MoneyFormat,
  },
  computed: mapState(["currentProduct"]),
  mounted() {
    this.getProduct();
  },
  methods: {
    getProduct() {
      this.$store
        .dispatch("GET_CURRENT_PRODUCT", this.$route.params.productid)
        .then((result) => {
          console.log(result);
          this.currentProduct = result;
          window.amplitude.getInstance().logEvent("Product Viewed", {
            device_id: "value",
            timestamp: new Date(),
            product_id: this.$route.params.productid,
          });
          this.images = this.currentProduct.images.split(";");
          for (let index = 0; index < this.images.length; index++) {
            this.images[index] = this.images[index] + "?version=" + uuid.v1();
          }
        });
    },
    goToBack() {
      this.$router.push({
        name: `ProductList`,
      });
    },
    share() {
      if (navigator.share) {
        window.amplitude.getInstance().logEvent("Product Shared", {
          timestamp: new Date(),
          product_id: this.$route.params.productid,
        });
        navigator
          .share({
            title: this.currentProduct.name,
            text: "Hola! te invito a revisar este producto",
            url: window.location.pathname,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      }
    },
    shareOnWhatsapp() {
      window.open(
        `https://api.whatsapp.com/send?phone=${this.$store.state.shop.whatsapp}&text=¡Hola! Mira este producto que vi en ${window.location.pathname} ¿Qué te parece si lo compramos en grupo para obtener un súper descuento?`,
        "_blank"
      );
    },
    buySingle() {
      window.amplitude.getInstance().logEvent("Individual Order Selected", {
        timestamp: new Date(),
        product_id: this.$route.params.productid,
      });
      window.open(
        `https://api.whatsapp.com/send?phone=${this.$store.state.shop.whatsapp}&text=¡Hola! Quiero comprar ${this.currentProduct.name} ahora!`,
        "_blank"
      );
    },
    buyGroup() {
      window.amplitude.getInstance().logEvent("Group Order Selected", {
        timestamp: new Date(),
        product_id: this.$route.params.productid,
      });
      window.open(
        `https://api.whatsapp.com/send?phone=${this.$store.state.shop.whatsapp}&text=¡Hola! Quiero comprar ${this.currentProduct.name} en grupo!`,
        "_blank"
      );
    },
  },
  data() {
    return {
      images: [],
      currencyCode: "USD",
      locale: "en",
    };
  },
};
</script>

<style scoped>
.img-size {
  width: 200px;
  height: 200px;
}

.slide {
  display: block;
  height: 500px;
  object-fit: cover;
  width: 100%;
}

.row-div {
  display: flex;
  justify-content: center;
}
/* Having some margin to make the two divs some distance */
.row-div > div {
  margin-right: 5px;
}

.link {
  text-align: center; 
  text-decoration: underline;
 
}

 a:visited { color:blue; }
</style>
